import { MailOutlined } from '@ant-design/icons';
import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '@framework/engine/schema/expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '@framework/engine/schema/rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '@framework/engine/schema/rules/repository/required/Required.rule.ts';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import {
  createEmailVerificationWidgetFormSchema,
  EmailVerificationWidgetRule,
} from './createEmailVerificationWidgetFormSchema.ts';
import { EmailVerificationWidgetComponent } from './EmailVerificationWidgetComponent.tsx';
import { EmailVerificationWidgetConfigComponent } from './EmailVerificationWidgetConfigComponent.tsx';
import { EmailVerificationWidgetConfigSchema } from './EmailVerificationWidgetConfigSchema.tsx';
import {
  type IEmailVerificationWidget,
  WidgetEmailVerificationType,
} from './IEmailVerificationWidget.ts';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    EmailVerification = 'emailVerification',
  }
}

/**
 * Widget per i,inserimento e verifica dell'email
 */
export const EmailVerificationWidgetType: IWidgetType<IEmailVerificationWidget> =
  {
    type: WidgetEmailVerificationType,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Advanced,
    name: 'Verifica Email',
    icon: <MailOutlined />,
    hasValue: true,
    getReference: getSimpleWidgetReference(Datatype.String),
    // getSiblingReferences: () => [],
    formComponent: EmailVerificationWidgetComponent,
    previewComponent: EmailVerificationWidgetComponent,
    createFormSchema: createEmailVerificationWidgetFormSchema,
    configValidator: EmailVerificationWidgetConfigSchema,
    configComponent: EmailVerificationWidgetConfigComponent,
    configOptions: {},
    // Traduzioni
    translationSchema: tran.widget({
      layout: tran.object({
        startButtonText: tran.string(),
        startHelpText: tran.rte(),
        endButtonText: tran.string(),
        endHelpText: tran.rte(),
      }),
    }),
    rules: [RequiredRule, CustomWarningsRule],
    fixedRules: [EmailVerificationWidgetRule],
  };
